var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 595.28",
    style: {
      enableBackground: "new 0 0 595.28 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#199D7A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -178.3096 439.7206)",
    className: "st0",
    cx: 441.63,
    cy: 435.1,
    rx: 81.88,
    ry: 81.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.45,217.8c15.17,8.86,33.37,13.08,52.76,10.38c36.73-5.12,65.99-35.37,69.84-72.26 c5.13-49.17-33.3-90.69-81.42-90.69c-15.03,0-29.07,4.12-41.18,11.19v-0.09c-21.56,13.74-41.87,25.81-58.66,35.43 c-27.38,15.68-60.93,15.68-88.3,0c-16.79-9.62-37.11-21.68-58.66-35.43v0.09c0,0,0,0,0,0c-1.46-0.85-2.95-1.66-4.46-2.42 c-0.23-0.12-0.46-0.22-0.69-0.33c-2.46-1.21-4.99-2.3-7.59-3.26c-0.76-0.28-1.51-0.57-2.28-0.83c-1.16-0.39-2.33-0.76-3.52-1.1 c-1.44-0.42-2.91-0.79-4.38-1.13c-0.98-0.22-1.97-0.45-2.96-0.64c-1.92-0.37-3.87-0.66-5.84-0.89c-0.7-0.08-1.41-0.15-2.12-0.22 c-2.42-0.22-4.86-0.37-7.34-0.37c-45.22,0-81.88,36.66-81.88,81.88c0,15.03,4.12,29.07,11.19,41.18h-0.09 c13.74,21.54,25.8,41.85,35.41,58.64c15.69,27.39,15.69,60.96,0,88.36c-9.62,16.79-21.68,37.09-35.41,58.64h0.09 c-8.86,15.17-13.09,33.38-10.38,52.76c5.13,36.73,35.38,65.99,72.27,69.84c49.17,5.13,90.69-33.3,90.69-81.42 c0-15.03-4.12-29.07-11.19-41.18h0.09c-13.74-21.54-25.8-41.85-35.41-58.64c-15.69-27.39-15.69-60.96,0-88.36 c0.07-0.12,0.14-0.24,0.21-0.36c15.23-26.57,37.3-48.64,63.88-63.88c0.12-0.07,0.24-0.14,0.36-0.21 c27.39-15.69,60.96-15.69,88.36,0c16.79,9.62,37.09,21.68,58.64,35.41V217.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a599a629025e8713cacc5b4dd2392642.svg";
export { ForwardRef as ReactComponent };